import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'radio-button',
  props: {
  name: { type: String, required: true },
  option: { type: [String, Boolean], required: true },
  color: { type: String, default: 'brand' },
  width: { type: [String, Number], default: 20 },
  value: { type: [String, Boolean], default: '' },
  label: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
},
  emits: ["input"],
  setup(__props, { emit }: { emit: ({
  (e: 'input', value: string | boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const initial = ref(props.value);

watch(
  () => props.value,
  (newVal) => {
    initial.value = newVal;
  }
);

// Methods
function onChange(value: string | boolean) {
  emit('input', value);
}

return { __sfc: true,props, emit, initial, onChange }
}

})